export default "__VITE_ASSET__CtKigCPw__"